module.exports = __webpack_public_path__ + "img/areus.8ec41808.png";